export default __webpack_public_path__ + "static/media/dashboard.a64ef20c.svg";